<template>
  <div class="row">
    <div class="col-12 mb-5">
      <div class="page_title">
        博覽會報名填選
      </div>
    </div>
    <div class="col-12 mb-5">
      <career-expo-introduce
        :expo-info="currentExpoInfoGetter"
      />
    </div>
    <div class="col-12 mb-5">
      <career-expo-choosing-booth
        ref="booths"
        :expo-info="currentExpoInfoGetter"
        :enrolled-expo-info="enrolledExpoInfo || {}"
        @submit="boothsChanged"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CareerExpoChoosingBooth from '../common/CareerExpoChoosingBooth'
import CareerExpoIntroduce from '../common/CareerExpoIntroduce'

export default {
  name: 'EnterpriseEditCareerExpo',
  components: {
    CareerExpoChoosingBooth,
    CareerExpoIntroduce
  },
  props: {
    enrolledExpoInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'currentExpoInfoGetter'
    ])
  },
  methods: {
    boothsChanged (careerExpo) {
      this.$emit('booths:changed', careerExpo)
    },
    resetBoothQuantity () {
      this.$refs.booths.resetQuantity()
    }
  }
}
</script>
